import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import useOnceEffect from '../Hooks/useOnceEffect';
import useToggle from '../Hooks/useToggle';
import addbutton from "../static/images/add-button.png";
import xbutton from "../static/images/X_icon.png";


const AreasInteres = ({ applicantProfileId, edit = false }) => {

    const [areas, setAreas] = useState([])
    const [applicantAreas, setApplicantAreas] = useState([])
    const [toggle, setToggle] = useToggle(false)

    function deleteArea(area) {

        axios.delete(`applicant-area/${area.applicantAreaId}`)
            .then(({data}) => {
                if(data.message === "1" ) {

                    setApplicantAreas(_old => {
                        let aux = _old.filter(elm => parseInt(elm.applicantAreaId) !== parseInt(area.applicantAreaId))
                        return [...aux]
                    })

                    toast.success("Area de interés eliminada")
                }else {
                    toast.error("No se pudo eliminar el area")
                }
            })
            .catch(() => toast.error("No se pudo eliminar el area"))
    }

    function addArea(areaId) {
        const data = {
            areaId: parseInt(areaId),
            applicantProfileId: applicantProfileId
        }

        if(areaId === null) {
            toast.error("Escoja un area de interés")
            return
        }

        if(isAlreadyOnList(areaId)) {
            setToggle()
            return
        }


        axios.post(`applicant-area`, data)
            .then(({data}) => {
                setApplicantAreas((_old) => ([..._old, data]))
                setToggle()
            })
            .catch(() => toast.error("Error al agregar area de interés"))

    }

    function isAlreadyOnList(areaId) {
        let isOnList = applicantAreas.find((elm) => parseInt(elm.area.areaId) === parseInt(areaId))

        return (isOnList !== undefined)
    }


    useOnceEffect(() => {

        let is_mounted = true

        axios.get("access/areas")
        .then(({data}) => is_mounted ? setAreas(data) : null)

        return () => {
            is_mounted = false
        }
    })

    useEffect(() => {

        if(applicantProfileId){
            axios.get(`applicant-area/${applicantProfileId}`)
                .then(({data}) => setApplicantAreas(data))
        }

    }, [applicantProfileId])

    return (
        <>
            <section>
                <div className="box right-col">
                    <div className="head">
                        <div className="title">Areas de interés</div>
                        {edit &&
                            <a href="#/" onClick={setToggle}>
                                <img src={addbutton} alt="area de interes"></img>
                            </a>
                        }
                    </div>

                    <Areas areas={applicantAreas} edit={edit} deleteArea={deleteArea} />
                </div>

            </section>

            <AddArea
                show={toggle}
                onClose={setToggle}
                areas={areas}
                onAdd={addArea}
            />
        </>
    );
};


function Areas({areas = [], edit = false, deleteArea = () => {} }) {

    const areasTag = areas.map((elm, i) => (
        <div className='tag' key={i}>
            {edit &&
                <span className='cierre-X' role="button" onClick={() => deleteArea(elm)}>
                    <img src={xbutton} style={{ width: "20px" }} alt="eliminar area" />
                </span>
            }
            {elm?.area.nombre}
        </div>
    ));

    return (
        <div className="tags-cloud">
            <div className="tags-cloud__wrapper">
                { areasTag }
            </div>
        </div>
    )
}

function AddArea({show, onClose, areas= [], onAdd}) {

    const [select, setSelect] = useState(null);

    return (
        <Modal show={show} onHide={onClose} className="kr-modal">
            <Modal.Header>
                <h2>Agregar area de interes</h2>
            </Modal.Header>

            <Modal.Body>

                <div className="container my-5">
                    <div className='form-group mb-3'>
                        <select className='form-control form-control-lg' onChange={({target}) => setSelect(target.value)}>
                            <option value={""} hidden>Escoja un area de interés</option>
                            {areas.map((elm, i) => <option key={i} value={elm.areaId}>{elm.nombre}</option>) }
                        </select>
                    </div>
                    <button className='btn btn--small btn--purple' onClick={() => onAdd(select)}>Agregar</button>
                </div>

            </Modal.Body>
        </Modal>
    )
}

export default AreasInteres;